// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rJ-z","hovered":"sJ-z","hoverImage":"tJ-z","mainImage":"uJ-z","imageNoBackground":"vJ-z","fullSizeImage":"wJ-z"};